import type { TFunction } from 'i18next';

const MEETING_CONFLICT_DETECTED = 4712;
const MEETING_CONFLICT_WARNING = 4723;

type ApiError = { data?: { message_code?: number; detail?: string } };

/**
 * Runs a meeting write; on a schedule-conflict warning asks the user and re-runs it with
 * confirm_conflicts. Resolves undefined when the user backs out or the tenant policy blocks it.
 */
export async function runWithConflictConfirm<T>(
  run: (confirmConflicts: boolean) => Promise<T>,
  t: TFunction,
): Promise<T | undefined> {
  try {
    return await run(false);
  } catch (err) {
    const data = (err as ApiError)?.data;
    if (data?.message_code === MEETING_CONFLICT_WARNING) {
      if (!window.confirm(t('meetings.conflictConfirm', { detail: data.detail ?? '' }))) return undefined;
      return run(true);
    }
    if (data?.message_code === MEETING_CONFLICT_DETECTED) {
      window.alert(t('meetings.conflictBlocked', { detail: data.detail ?? '' }));
      return undefined;
    }
    throw err;
  }
}
